import { SubAPI } from "./SubAPI";
import {Paginated} from "./Users";
import {DimensionedExtras, MiscProduct} from "./MiscProducts";

export class QuoteMiscProducts extends SubAPI {
    list(input: {
        project: number
        alternative: number;
        offset?: number;
    }) {
        return this.fetcher.get<Paginated<MiscProduct>>("/api/quote-misc-products", input)
    }

    upsert(input: MiscProduct & DimensionedExtras) {
        return this.fetcher.post("/api/quote-misc-product", input)
    }
}

